import React from 'react';
import { Img } from '@react-email/components';

const Header = ({
  src,
  style,
}: {
  src: string;
  style?: React.CSSProperties;
}) => (
  <Img
    width={'25%'}
    style={{ margin: '30px auto', maxWidth: '200px', ...style }}
    src={src}
  />
);

export default Header;
